var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProximity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H9V11C9.53044 11 10.0391 10.7893 10.4142 10.4142C10.7893 10.0391 11 9.53043 11 9ZM16.3333 9H15C15 10.5913 14.3679 12.1174 13.2427 13.2426C12.1174 14.3679 10.5913 15 9 15V16.3333C13.0533 16.3333 16.3333 13.0467 16.3333 9ZM13.6667 9H12.3333C12.3333 9.88406 11.9821 10.7319 11.357 11.357C10.7319 11.9821 9.88406 12.3333 9 12.3333V13.6667C10.2377 13.6667 11.4247 13.175 12.2998 12.2998C13.175 11.4247 13.6667 10.2377 13.6667 9ZM13.6667 21H15C15 19.4087 15.6321 17.8826 16.7574 16.7574C17.8826 15.6321 19.4087 15 21 15V13.6667C19.0551 13.6667 17.1899 14.4393 15.8145 15.8146C14.4393 17.1898 13.6667 19.0551 13.6667 21ZM19 21H21V19C20.4696 19 19.9609 19.2107 19.5858 19.5858C19.2108 19.9609 19 20.4696 19 21ZM16.3333 21H17.6667C17.6667 20.1159 18.0179 19.2681 18.643 18.643C19.2681 18.0179 20.116 17.6667 21 17.6667V16.3333C19.7624 16.3333 18.5754 16.825 17.7002 17.7002C16.825 18.5753 16.3333 19.7623 16.3333 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProximity);
export default __webpack_public_path__ + "static/media/Proximity.4d95b0abfe08945cfee817d1d4a92a0e.svg";
export { ForwardRef as ReactComponent };